/**
 * Catálogo cerrado de los textos fijos de la ficha (diseño 4a §6; etapa 4, PR 3), compartido por Argus Team y Nexo desde el corte 4c.
 * La ficha no redacta: todo lo que muestra sale del documento argus.hallazgos/1, del catálogo de las piezas (../piezas/rotulos.ts) o de
 * aquí. La prueba W2 (argus-team-web/web/src/components/Ficha.test.tsx) lo comprueba sobre los casos de oro y los fixtures, y la prueba
 * del texto visible (app/scripts/glosario_texto_visible_test.ts) pasa cada texto por el glosario.
 *
 * Estado de aprobación (bitácora 2026-10-03-etapa4-piezas.md): los textos con número son los de §6, aprobados por Bernardo sobre las
 * capturas de dev:mock el 2026-10-04, igual que los marcados «por aprobar» del PR 3 (aprobados en esa misma revisión), salvo
 * `detalleSinActas`, que sigue por aprobar (revisión del PR 3, I4).
 *
 * Corte 4c: se movió aquí desde argus-team-web/web/src/lib/rotulos-ficha.ts (retirado); Argus Team lo importa de '@rotulos'.
 */
import type { Hallazgos } from '../piezas/index.ts';

export const FICHA = {
  // 1, 1b, 2. Estado en la lista.
  listaConsultada: 'Lista de OFAC consultada el {fecha}.',
  listaSinFecha: 'No sabemos la fecha de la última consulta a la lista de OFAC.',
  relacionesCalculadas: 'Relaciones calculadas con la lista de OFAC del {fecha}.',
  // 3, 4. La primera pregunta.
  mismaPersona: '¿Es la misma persona que tu cliente?',
  // Con un cliente empresa (Bernardo, 2026-10-04, al aprobar las capturas).
  mismaEmpresa: '¿Es la misma empresa que tu cliente?',
  escribeDatos: 'Escribe los datos de tu cliente en el buscador para compararlos.',
  // 37 (servicio en el diseño; aquí, con el tipo del sujeto). Etapa 5 (Bernardo, 2026-10-06): se retiraron «esta {tipo} encontrada y
  // otra(s) {k} son la misma {tipo}»; la ficha de lo que el equipo unió no anuncia un grupo.
  equipoOtra: 'Tu equipo decidió que esta {tipo} encontrada es otra {tipo}.',
  // Pendiente m4 del PR 2 (por aprobar): la decisión del equipo no se pudo leer; no es «sin decisión».
  equipoNoLeido: 'No pudimos leer la decisión de tu equipo.',
  // 35 y su singular (por aprobar).
  masPersonasVarias: 'Hay {n} {tipos} encontradas más en el Registro Público de Comercio que son esta {tipo} de la lista de OFAC.',
  masPersonasUna: 'Hay 1 {tipo} encontrada más en el Registro Público de Comercio que es esta {tipo} de la lista de OFAC.',
  // 10, 12.
  // Escala de riesgo (Bernardo, 2026-10-06): el rótulo del nivel dice el riesgo; el encabezado lo nombra.
  siEsTuCliente: 'Riesgo si es tu cliente',
  queHacer: 'Qué hacer',
  // 13, 14.
  comoSeRelaciona: 'Cómo se relaciona con los sancionados',
  segunActas: 'Según actas del Registro Público de Comercio',
  segunOfac: 'Según la lista de OFAC',
  segunActasYOfac: 'Según actas del Registro Público de Comercio y la lista de OFAC',
  // 28 a 30, 34.
  loQueNoSabemos: 'Lo que no sabemos',
  siSeConfirma: 'Riesgo si se confirma: {nivel}',
  pideCliente: 'Se le pide a tu cliente:',
  pideCuentas: 'Se le pide al área de cuentas:',
  pideAnalista: 'Lo revisa quien analiza el caso:',
  masHuecosVarios: 'Hay {n} cosas más que no sabemos; están en el detalle.',
  masHuecosUno: 'Hay 1 cosa más que no sabemos; está en el detalle.',
  // 31 a 33 (31 en singular, por aprobar).
  detalleVarias: 'Detalle: {n} actas, las relaciones lejanas y los programas de OFAC',
  detalleUna: 'Detalle: 1 acta, las relaciones lejanas y los programas de OFAC',
  // Por aprobar (revisión del PR 3, I4): un detalle con contenido y sin actas (p. ej. sólo los programas de OFAC), nunca «0 actas».
  detalleSinActas: 'Detalle: las relaciones lejanas y los programas de OFAC',
  relacionesCon: 'Relaciones con {nombre} en las actas',
  fechaActa: 'Fecha del acta',
  programas: 'Programas de OFAC',
  // 38, 39.
  otrasListas: 'Contexto de otras listas: no cambia la gravedad.',
  queEvalua: 'Qué evalúa',
  // 40 a 45b. Ver la fuente.
  verFuente: 'Ver la fuente',
  laFuente: 'La fuente',
  actaRpc: 'Acta del Registro Público de Comercio',
  pagina: 'Página {n}',
  diceActa: 'Lo que dice el acta:',
  textoEsta: 'El texto está en el acta.',
  textoNoEsta: 'El texto no está en el acta.',
  paginaCorrecta: 'La página es la correcta.',
  paginaIncorrecta: 'La página no es la correcta.',
  actaNombra: 'El acta nombra a {nombre}.',
  actaNoNombra: 'El acta no nombra a {nombre}.',
  sinComprobar: 'Sin comprobar.',
  sinPagina: 'Todavía no podemos mostrar la página del acta.',
  copiaConsultada: 'Nuestra copia, consultada el {fecha}',
  suRegistro: 'Su registro en la lista de OFAC',
  abrirOficial: 'Abrir en el sitio oficial',
  comunicado: 'Comunicado del Departamento del Tesoro, {fecha}',
  comunicadoSinFecha: 'Comunicado del Departamento del Tesoro',
  noVigente: 'Esta versión del comunicado ya no es la vigente.',
  // Rótulos del acto completo en el visor (por aprobar: §2.9 pide estos datos y §6 no les da rótulo).
  fechaInstrumento: 'Fecha de la escritura',
  fechaInscripcion: 'Fecha de inscripción',
  accionesDe: '{n} de {m} acciones',
  porcentajeImpreso: 'Porcentaje que dice el acta: {n} %',
  cerrar: 'Cerrar',
  // 46, 53. Carga y errores (los mensajes de error vienen del servidor).
  buscarDeNuevo: 'Buscar de nuevo',
  reintentar: 'Reintentar',
  cargando: 'Cargando la ficha…',
  // 52: el documento no pasó la lectura defensiva (leerHallazgos) o la base no tiene el lote 0a.
  ilegible: 'No pudimos leer esta ficha.',
  sigueCargando: 'Sigue cargando…',
  // 54, 55. Los datos de tu cliente en el buscador (PR 4): sólo en la memoria de la pantalla.
  fechaNacimiento: 'Fecha de nacimiento',
  fechaConstitucion: 'Fecha de constitución',
  ciudadDomicilio: 'Ciudad del domicilio',
  estadoDomicilio: 'Estado del domicilio',
  ciudadNacimiento: 'Ciudad de nacimiento',
  estadoNacimiento: 'Estado de nacimiento',
  rfcOCurp: 'RFC o CURP',
  noEnviaNiGuarda: 'Argus no envía ni guarda estos datos.',
  // 56, 60. Buscador y «Decisión».
  siEsTuClienteNivel: 'Riesgo si es tu cliente: {etiqueta}',
  verRelacion: 'Ver la relación',
  verLaFicha: 'Ver la ficha',
  ocultarFicha: 'Ocultar la ficha',
  // 4d (Bernardo, 2026-10-05, ajuste 1; por aprobar): lo que dicen las fuentes de la persona o empresa encontrada, bajo su nombre, con
  // «Ver la fuente» por dato. El título dice de dónde salen los datos (sujeto.datos[].fuente.tipo); sin datos, lo dice.
  datosActas: 'Lo que dicen las actas de esta {tipo}',
  datosLista: 'Lo que dice la lista de OFAC de esta {tipo}',
  datosListaYActas: 'Lo que dicen la lista de OFAC y las actas de esta {tipo}',
  soloNombreActas: 'Las actas sólo traen su nombre.',
  soloNombreLista: 'La lista de OFAC no trae más datos de esta {tipo} para compararla con tu cliente.',
  // 4d (ajuste 2; por aprobar): con quién de la lista coincide la persona o empresa encontrada (identidad_lista.con). Va seguido de
  // `sancionados[con].por_que.texto` («OFAC lo sancionó el … Está en la lista por …»), que trae el programa con su concordancia.
  puedeSer: 'Puede ser {nombre}.',
  esLaDeLaLista: 'Es {nombre}.',
  // Ajustes 4d, punto 5 (por aprobar, pedido del coordinador): con `sancionados[con].sancion` (20261005120000), una sola oración con la
  // frase {sancion} de las variantes («sancionada por narcotráfico (Ley Kingpin)»). Sin el campo (base anterior), las dos de arriba.
  puedeSerSancion: 'Puede ser {nombre}, {sancion}.',
  esLaDeLaListaSancion: 'Es {nombre}, {sancion}.',
  // 4d, revisión (aprobado por delegación del coordinador, 2026-10-05): una liga externa lo dice en su nombre accesible; a la vista,
  // un «↗» junto a «Ver la fuente».
  seAbreEnOtraPestana: '(se abre en otra pestaña)',
} as const;

/**
 * 4d (ajuste 1): el rótulo de cada dato de `sujeto.datos` (el enum `campo` del contrato). Los aprobados se repiten tal cual: «Fecha de
 * nacimiento» y «Fecha de constitución» (54), «Domicilio» y «Lugar de nacimiento» (CAMPO de las piezas), «RFC» y «CURP», «Nombre» y
 * «Número en el Registro Público de Comercio» (visor de fuentes, 4b). Por aprobar: «Nacionalidad», «Sexo» y «Empresa que nombra el
 * acta» (las dos primeras sí las manda hoy nexo.sujeto_datos; la tercera no, pero el enum la admite).
 */
export const DATO_SUJETO: Record<Hallazgos['sujeto']['datos'][number]['campo'], string> = {
  nombre: 'Nombre',
  nacimiento: 'Fecha de nacimiento',
  constitucion: 'Fecha de constitución',
  lugar_nacimiento: 'Lugar de nacimiento',
  domicilio: 'Domicilio',
  rfc: 'RFC',
  curp: 'CURP',
  nacionalidad: 'Nacionalidad',
  sexo: 'Sexo',
  folio_mercantil: 'Número en el Registro Público de Comercio',
  empresa_nombrada: 'Empresa que nombra el acta',
  // Aprobado por Bernardo el 2026-10-16. Hoy nexo.sujeto_datos no la manda; el enum la admite (campo de la identidad).
  persona_nombrada: 'Persona que OFAC nombra',
};

/** Llena un texto del catálogo; un hueco sin valor es un error de programación, no un texto a medias. */
export function texto(plantilla: string, valores: Record<string, string | number> = {}): string {
  return plantilla.replace(/\{(\w+)\}/g, (_, k: string) => {
    if (!(k in valores)) throw new Error(`texto sin valor para {${k}}: ${plantilla}`);
    return String(valores[k]);
  });
}

/** «persona» o «empresa», como lo dice el tipo del sujeto (B3 y 37). */
export const tipoSujeto = (doc: Hallazgos) => (doc.sujeto.tipo === 'empresa' ? 'empresa' : 'persona');

/** Todos los textos del catálogo, para las pruebas (W2 y el glosario). */
export const textosFicha = (): string[] => [...Object.values(FICHA), ...Object.values(DATO_SUJETO)];
